import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '../lib/queryClient';
import { AuthProvider } from '../helpers/useAuth';
import { ThemeModeProvider } from '../helpers/themeMode';
import { LocalizationProvider } from '../helpers/useLocalization';
import { TooltipProvider } from './Tooltip';
import { SonnerToaster } from './SonnerToaster';
import { ScrollToHashElement } from './ScrollToHashElement';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Conservative defaults while debugging API routing issues:
      // - avoid automatic retries which can create tight loops on 404s
      // - don't refetch on window focus or reconnect
      staleTime: 60 * 1000, // 1 minute "fresh" window
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export const GlobalContextProviders = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeModeProvider>
          <LocalizationProvider>
            <ScrollToHashElement />
            <TooltipProvider>
              {children}
              <SonnerToaster />
            </TooltipProvider>
          </LocalizationProvider>
        </ThemeModeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
